import tempLogo from '../static/images/temporary_logo.png';
import { Link } from "react-router-dom";

const FullModal = ({children, items, desktopItems, px }) => {
    return (
        <div className={`bg-[#f7f7f8] absolute top-0 right-0 bottom-0 left-0 z-100 px-${px} flex flex-col items-${items} lg:items-${desktopItems}`}>
            {/* Logo */}
            <div className="w-full flex justify-center my-8">
                <Link to="/"><img src={tempLogo} alt="TicinoWild Logo" className='w-32' /></Link>
            </div>
            {children}
        </div>
    )
}

export default FullModal;